var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 17.4987V3.95703L4.83366 0.832031L9.00033 3.95703V5.83203H17.3337V17.4987H0.666992ZM2.33366 15.832H4.00033V14.1654H2.33366V15.832ZM2.33366 12.4987H4.00033V10.832H2.33366V12.4987ZM2.33366 9.16536H4.00033V7.4987H2.33366V9.16536ZM2.33366 5.83203H4.00033V4.16536H2.33366V5.83203ZM5.66699 5.83203H7.33366V4.16536H5.66699V5.83203ZM5.66699 15.832H15.667V7.4987H5.66699V15.832ZM10.667 10.832V9.16536H14.0003V10.832H10.667ZM10.667 14.1654V12.4987H14.0003V14.1654H10.667ZM7.33366 10.832V9.16536H9.00033V10.832H7.33366ZM7.33366 14.1654V12.4987H9.00033V14.1654H7.33366Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.83a0420ca90bd4c6966584ee9f40e40c.svg";
export { ForwardRef as ReactComponent };